// extracted by mini-css-extract-plugin
export default {"section":"AboutWelcomeSection_section__4mCFa","section_children":"AboutWelcomeSection_section_children__D65+k"};